import { maskAutoCompleteRecipient } from '../services/maskAutoCompleteRecipient';
import deleteFromCache from 'owa-recipient-cache/lib/selectors/deleteFromCache';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('maskRecipientFromFindControl')(function maskRecipientFromFindControl(
    recipientWell: FindControlViewState,
    recipientToMask: FindRecipientPersonaType
) {
    // Remove Recipient from Find Control and Cache.
    recipientWell.findResultSet = recipientWell.findResultSet.filter(curObj => {
        return curObj !== recipientToMask;
    });
    deleteFromCache(recipientToMask.EmailAddress);

    // Mask Recipient Well
    maskAutoCompleteRecipient(recipientToMask.EmailAddress.EmailAddress);
});
